
module.exports = {
    ADMIN: 1,
    CONSULTANT: 2,
    COMPANY_ADMIN: 3,
    COMPANY_EXEC: 4,
    USER: 5,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/user-types.js
// module id = 466
// module chunks = 58